export default __webpack_public_path__ + "static/media/logo-apoel.64756518.svg";